import {
	dissolve,
	fadeIn,
	instant,
	slideIn,
	smoothMove,
	smoothRotate
} from '../../../../three-helpers/animation/transition-helpers';
import type { TransitionConfigRegistry } from '../../../types/engine.types';

/**
 * Get the default transition registry with assembly-visible durations
 *
 * This defines the animation configurations for each object type:
 * - panel: Cabinet panels
 * - countertop: Counter surfaces
 * - corner: Corner pieces
 * - trim: Decorative trim
 * - appliance: Kitchen appliances
 * - cutout: Holes for sinks, cooktops, etc.
 * - island: Kitchen island groups
 * - floor: Floor geometry
 * - debug: Debug visualization objects
 */
export const getDefaultTransitionRegistry = (): TransitionConfigRegistry => ({
	panel: {
		initialize: { duration: 200, helper: fadeIn },
		add: { duration: 800, helper: fadeIn },
		remove: { duration: 600, helper: dissolve }
	},
	countertop: {
		initialize: { duration: 450, helper: fadeIn },
		add: { duration: 1000, helper: fadeIn },
		remove: { duration: 600, helper: dissolve }
	},
	corner: {
		initialize: { duration: 300, helper: fadeIn },
		add: { duration: 600, helper: fadeIn },
		remove: { duration: 400, helper: dissolve }
	},
	trim: {
		initialize: { duration: 450, helper: fadeIn },
		add: { duration: 600, helper: fadeIn },
		remove: { duration: 400, helper: dissolve }
	},
	appliance: {
		initialize: { duration: 700, helper: slideIn, flyPhases: { fadeIn: 300, slide: 400 } },
		add: { duration: 700, helper: slideIn, flyPhases: { fadeIn: 300, slide: 400 } },
		remove: { duration: 600, helper: dissolve },
		move: { duration: 800, helper: smoothMove },
		rotate: { duration: 600, helper: smoothRotate }
	},
	cutout: {
		initialize: { duration: 900, helper: fadeIn },
		add: { duration: 400, helper: instant },
		remove: { duration: 300, helper: instant }
	},
	island: {
		initialize: { duration: 400, helper: fadeIn },
		add: { duration: 400, helper: fadeIn },
		remove: { duration: 600, helper: dissolve }
	},
	floor: {
		initialize: { duration: 100, helper: fadeIn },
		add: { duration: 600, helper: fadeIn },
		remove: { duration: 400, helper: fadeIn }
	},
	debug: {
		initialize: { duration: 200, helper: instant },
		add: { duration: 200, helper: instant },
		remove: { duration: 200, helper: instant }
	}
});
